module.exports = __webpack_public_path__ + "img/content-19.050e5fe.jpg";